import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { ButtonProps, IconButton } from '@mui/material';
import {
  GridRenderCellParams,
  gridFilteredDescendantCountLookupSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';

export const AbsenceHistoryGridTreeDataGroupingCell = (
  props: GridRenderCellParams,
) => {
  const { id, field, rowNode } = props;
  const apiRef = useGridApiContext();
  const filteredDescendantCountLookup = useGridSelector(
    apiRef,
    gridFilteredDescendantCountLookupSelector,
  );
  const filteredDescendantCount =
    filteredDescendantCountLookup[rowNode.id] ?? 0;

  const handleClick: ButtonProps['onClick'] = (event) => {
    if ('childrenExpanded' in rowNode) {
      apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    }
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  if (filteredDescendantCount > 0) {
    return (
      <IconButton onClick={handleClick} tabIndex={-1} size={'small'}>
        {'childrenExpanded' in rowNode && rowNode.childrenExpanded ? (
          <KeyboardArrowDown fontSize={'small'} />
        ) : (
          <KeyboardArrowRight fontSize={'small'} />
        )}
      </IconButton>
    );
  }

  return <></>;
};
